#import "../fragments/lead-basic.graphql"
#import "../fragments/account-basic.graphql"
#import "../fragments/contact-basic.graphql"

query GetRelatedEntitiesSearchResults($query: String) {
    search(query: $query) {
        quickResults {
            recentResults {
                ... on Lead {
                    ...LeadBasic
                }
                ... on Account {
                    ...AccountBasic
                }
                ... on Contact {
                    ...ContactBasic
                }
            }
            topResults {
                ... on Lead {
                    ...LeadBasic
                }
                ... on Account {
                    ...AccountBasic
                }
                ... on Contact {
                    ...ContactBasic
                }
            }
        }
    }
}
